import { render, staticRenderFns } from "./NewEditor.vue?vue&type=template&id=9d923486&scoped=true&"
import script from "./NewEditor.vue?vue&type=script&lang=js&"
export * from "./NewEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewEditor.vue?vue&type=style&index=0&id=9d923486&scoped=true&lang=scss&"
import style1 from "./NewEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d923486",
  null
  
)

export default component.exports